<template>
  <el-footer>
    <a style="color: white" href="https://jl.jijiane.cn">@简历制作</a>&nbsp;&nbsp;
    <a style="color: white" href="https://dh.jijiane.cn">@极简E导航</a>&nbsp;&nbsp;
    <a style="color: white" href="https://yx.jijiane.cn">@怀旧游戏</a>&nbsp;&nbsp;
    <a style="color: white" href="http://xs.jijiane.cn">@精品小说屋</a>
    <div style="text-align: center; color: white" >
      <span>备案号：<a href="https://beian.miit.gov.cn/" target="_blank" style="color: white ;text-decoration: none;">蜀ICP备2024079187号-3</a></span>
    </div>
  </el-footer>
</template>
<script>
export default {
  name: "JjeFooter"
}
</script>
<style scoped>

</style>
